module.exports = __webpack_public_path__ + "img/kep5.891e5a6c.jpg";